import React, { Component } from 'react';
import { Table } from 'antd'; 

class ComTable extends Component {
    getColumns = () => {
        const { config } = this.props;
        const columns = config.map(item => {
            const { key } = item;
            return {
                ...item,
                dataIndex: key,
            };
        });
        return columns;
    }

    getDataSource = () => {
        const { data } = this.props;
        const dataSource = data?data.map((item, index) => ({
            index: index + 1,
            ...item,
        })):'';
        return dataSource;
    }

    handleTableChange = (pagination, filters, sorter) => {
        const { sortParams = {} } = this.props;
        sortParams.sort = sorter.field ;
        sortParams.direction = sorter.order ? sorter.order == 'descend' ? 'DESC' : 'ASC' : '';
        this.props.onChange({ pagination, sortParams})
    }
    
    render() {
        const { loading, pagination, getDataSource } = this.props;
        return (
            <Table
                bordered
                loading={loading}
                // scroll={{x: 1080}}
                pagination={pagination}
                columns={this.getColumns()}
                dataSource={getDataSource ? getDataSource() : this.getDataSource()}
                rowKey={row => row.index}
                onChange={this.handleTableChange}
            />
        );
    }
}

export default ComTable;


// WEBPACK FOOTER //
// ./src/components/common/ComTable.js